module.exports = __webpack_public_path__ + "img/banner-10.41022872.jpg";